module.exports = __webpack_public_path__ + "static/img/create.87ecdfdd.png";